import Constants from 'common/constants'
import { setRedirectRoute } from 'router/redirect'
// import AuthModule from 'common/auth'
//import { setRedirectRoute } from 'router/redirect'
//import i18n from 'common/i18n'
import { toastService } from 'common/services/toast/service'

const getToken = (): string => {
  try {
    const token = localStorage.getItem(Constants.TOKEN_LOCAL_STORAGE) || ''
    return token !== '' ? `Bearer ${token}` : ''
  } catch {
    return ''
  }
}

const clearToken = () => {
  localStorage.removeItem(Constants.AUTH_LOCAL_STORAGE)
  localStorage.removeItem(Constants.TOKEN_LOCAL_STORAGE)
  setRedirectRoute()
  window.location.href = '/login'
}

async function fetchData<T>(
  basePath: string,
  options?: RequestInit,
  muteException?: boolean
): Promise<T> {
  try {
    const withCredentials = options?.credentials !== 'omit'
    const token = getToken()
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        ...(withCredentials ? { Authorization: token } : {})
      },
      ...(options || {})
    }

    const response = await fetch(basePath, requestOptions)

    let payload = {} as T
    try {
      payload = await response.json()
    } catch (err: any) {
      payload = {
        message: 'Erro no servidor. Tente novamente.',
        exception: 'ServerError'
      } as T
    }

    if (response.ok) {
      return Promise.resolve(payload)
    } else {
      return Promise.reject(payload)
    }
  } catch (err: any) {
    if (!muteException) {
      toastService.showToast(
        err,
        err?.exception === 'UsernameExistsException' ? 'warning' : 'error',
        true
      )
    }
    return Promise.reject(err)
  }
}

function get<T>(
  basePath: string,
  options?: RequestInit,
  muteException?: boolean
): Promise<T> {
  return fetchData<T>(basePath, options, muteException)
}

function update<T, R>(
  basePath: string,
  method: string,
  body?: T,
  options?: RequestInit,
  muteException?: boolean
): Promise<R> {
  const optionsParam = options || {}

  return fetchData<R>(
    basePath,
    {
      ...optionsParam,
      method: method,
      body:
        body instanceof FormData || body instanceof Blob
          ? body
          : JSON.stringify(body)
    },
    muteException
  )
}

function post<T, R>(
  basePath: string,
  body: T,
  options?: RequestInit,
  muteException?: boolean
): Promise<R> {
  return update<T, R>(basePath, 'POST', body, options, muteException)
}

function put<T, R>(
  basePath: string,
  body: T,
  options?: RequestInit,
  muteException?: boolean
): Promise<R> {
  return update<T, R>(basePath, 'PUT', body, options, muteException)
}

function remove<T, R>(
  basePath: string,
  body?: T,
  options?: RequestInit,
  muteException?: boolean
): Promise<R> {
  return update<T, R>(basePath, 'DELETE', body, options, muteException)
}

const httpMethods = {
  get,
  post,
  put,
  remove
}

export default httpMethods
